import $ from 'jquery';
import * as Filter from './Filter';
import * as Renderer from './Renderer';

export default class CollectionFilters {
  constructor($el) {
    this.$el = $el;
    this.selected_filters = [];

    this.init = this.init.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);

    const json_url = window.location.search.length > 0
     ? `${window.location.href}&view=json`
     : '?view=json';

    $.get(json_url, (res) => {
      this.collection_data = JSON.parse(res);
      this.init();
    });
  } 

  init() {
    $(document).on('change', '[data-collection-filter-checkbox]', this.handleFilterChange);
    $(document).on('click', '[data-dropdown-heading]', (e) => {
      const $el = $(e.currentTarget);
      $el.toggleClass('expanded');
      $el.siblings('[data-dropdown-container]').toggleClass('revealed');

      if ($el.hasClass('expanded')) {
        $el.siblings('[data-close-dropdown]').addClass('enabled');
      } else {
        $el.siblings('[data-close-dropdown]').removeClass('enabled');
      }
    });
    $(document).on('click touchend', '[data-close-dropdown]', this.closeAllDropdowns);

    this.$el.addClass('ready');
  }

  closeAllDropdowns() {
    $('[data-dropdown-heading]').removeClass('expanded');
    $('[data-dropdown-container]').removeClass('revealed');
    $('[data-close-dropdown]').removeClass('enabled');  
  }

  handleFilterChange(e) {
    const $el = $(e.currentTarget);

    // If all, toggle all siblings
    if ($el.val() === 'all') {
      $el
        .closest('[data-filter-set]')
        .find('input[type=checkbox]')
        .prop('checked', $el.prop('checked'));
    }

    this.selected_filters = Filter.getSelectedFilters(this.$el);
    this.filtered_products = Filter.getFilteredProducts(this.collection_data.products, this.selected_filters);
    
    const products_string = Renderer.getProductsElements(this.filtered_products);

    if (this.selected_filters.length > 0) {
      $('[data-filtered-collection]').html(products_string);

      $('[data-filtered-collection]').show();
      $('[data-unfiltered-collection]').hide(); 
      $('.Pagination').hide();
    } else {
      $('[data-filtered-collection]').hide();
      $('[data-unfiltered-collection]').show();
      $('.Pagination').show();
    }

    window.setTimeout(() => {
      $(window).resize();
      $(window).scroll();
    }, 0);
  }
}
